import Axios from 'axios';
import { getEnvValue } from './Environment';
import {
  getAdminRefreshToken,
  getAdminToken,
  isAdminLoggedIn,
  logout,
  setAdminToken,
} from './localStroageHandler';
import routes from './Routes';

export const axios = Axios.create({
  baseURL: getEnvValue('REACT_APP_API_URL'),
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    console.log('error');
    const originalRequest = error.config;

    if (
      error?.response &&
      error?.response?.status === 401 &&
      !originalRequest._retry &&
      isAdminLoggedIn() == true
    ) {
      originalRequest._retry = true;
      const refreshToken = getAdminRefreshToken();
      return axios
        .get('api/user/token/refresh/', {
          params: { refresh_token: refreshToken },
        })
        .then(async (res) => {
          if (res.status === 200) {
            await setAdminToken(res.data.access_token);
            // await setAdminRefreshToken(res.data.refreshToken);
            originalRequest.headers['Authorization'] =
              'Bearer ' + getAdminToken();
            return axios(originalRequest);
          }
        })
        .catch((e) => {
          console.log(e, 'refresh error');
          logout();
          window.location.href = routes.admin.login;
          window.location.reload();
        });
    }
    return Promise.reject(error);
  }
);
